import { ProjectBoardProvider } from "@timenotes/shared/src/features/project-board"
import { message } from "antd"
import { TaskDetailsModalProvider } from "components/timenotes/tasks/task-details-modal/task-details-modal"

export const ProjectBoardContextWrapper = (props: React.PropsWithChildren) => {

  const onFilteredTaskCreated = () => {
    message.success('Due to the filters applied, task you have created might not be visible!')
  }

  return (
    <ProjectBoardProvider value={{ onFilteredTaskCreated }}>
      <TaskDetailsModalProvider>
        {props.children}
      </TaskDetailsModalProvider>
    </ProjectBoardProvider>
  )
}
